import './titulo.css'
const Titulo = ({ children }) => {
    return (
        <h2 className="title-secondary">
            {children}
        </h2>
    )
}
export default Titulo